import { defineMessages } from 'react-intl';

export const i18n: {
	app: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	all: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	appSelectPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	appSelectLabelSelected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	appSelectLabelUnselected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	appRedirectTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	app: {
		id: 'search-page.filters.names.app-select',
		defaultMessage: 'App',
		description: 'Label for filtering by app',
	},
	all: {
		id: 'search-page.filter.app-select.all',
		defaultMessage: 'All',
		description: 'Label for selecting all apps in the app select filter',
	},
	appSelectPlaceholder: {
		id: 'search-page.filter.app-select.placeholder',
		defaultMessage: 'Find app',
		description: 'Placeholder for app select filter search input',
	},
	appSelectLabelSelected: {
		id: 'search-page.filter.app-select.label.selected',
		defaultMessage: 'Selected',
		description: 'Label for when a filter option is selected',
	},
	appSelectLabelUnselected: {
		id: 'search-page.filter.app-select.label.unselected',
		defaultMessage: 'Suggested',
		description: 'Label for when a filter option is suggested',
	},
	appRedirectTooltip: {
		id: 'search-page.filter.app-select.tooltip.redirect',
		defaultMessage: 'Open a full page search filtered by {appLabel} results',
		description: 'Label for the tooltip when a app option is hovered',
	},
});
